import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';
import PageContainer from '../../components/layout/PageContainer';
import Button from '../../components/common/Button';
import { translate } from '../../utils/Common';
import styles from './Forbidden403.module.css';

/**
 * Pantalla mostrada cuando el usuario intenta abrir una ruta sin permiso (gate BLI / rol).
 */
const Forbidden403 = () => {
    const history = useHistory();
    const { url } = useRouteMatch();

    const handleBack = () => {
        if (window.history.length > 1) {
            history.goBack();
        } else {
            history.push(`${url}/`);
        }
    };

    return (
        <PageContainer maxWidth="md" padding="lg">
            <div className={styles.wrap} role="status" aria-live="polite">
                <div className={styles.iconWrap} aria-hidden>
                    <FaLock className={styles.icon} />
                </div>
                <h1 className={styles.title}>{translate('global.forbidden403.title')}</h1>
                <p className={styles.message}>{translate('global.forbidden403.message')}</p>
                <Button variant="primary" type="button" onClick={handleBack}>
                    {translate('global.forbidden403.back')}
                </Button>
            </div>
        </PageContainer>
    );
};

export default Forbidden403;
